import React from "react";
import { Modal, Select } from "antd";
import NavigationButton from "../navigation_button";
import CustomDropdown from "../dropdownfiled";
import { PartnerType } from "../../../homepage_partner/dtos/partner.dtos";
interface OptionProps {
  id: string;
  name: string;
}
interface AddMarketModalProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  selectedToAdd: OptionProps[] | null;
  setSelectedToAdd: (value: OptionProps[] | null) => void;
  selectedMarkets: { name: string }[];
  setSelectedMarkets: React.Dispatch<React.SetStateAction<any[]>>;
  setData: 
  React.Dispatch<React.SetStateAction<PartnerType>>;

  allMarkets: OptionProps[];
}

const AddMarketModal: React.FC<AddMarketModalProps> = ({
  isOpen,
  setIsOpen,
  selectedToAdd,
  setSelectedToAdd,
  selectedMarkets,
  setSelectedMarkets,
  allMarkets,
  setData,
}) => {
  const handleSave = () => {
    if (!selectedToAdd || selectedToAdd.length === 0) return;

    const newMarkets = selectedToAdd.map((market) => ({
      id: market.id,
      name: market.name,
      serviceScope: {
        healthSupplements: [],
        beautyAndSkin: [],
        foodAndBeverages: [],
        petNutrition: [],
        keyChannelCoverage: [],
        keyCapabilities: [],
        warehousing: [],
        acceptedBusinessModels: [],
        tradingTerms: [],
        minimumExclusivityTenure: [],
        preferenceonMarketingInvestment: [],
        paymentTerms: [],
      },
    }));
    setSelectedMarkets((prev) => [...prev, ...newMarkets]);
    setData((current) => {
      const currentMarkets = current.markets || {};

      const updatedMarkets = { ...currentMarkets };

      // Add new selected markets (if not already present)
      selectedToAdd.forEach((market) => {
        if (!updatedMarkets[market.name]) {
          updatedMarkets[market.name] = {
            focus_categories: {},
            region: 0,
            channel_coverage: [],
            service_capabilities: [],
            warehousing: [],
            engagement_model: [],
            trading_terms: "",
            minimum_tenure: "",
            trade_marketing_investments: "",
            payment_terms: [],
          };
        }
      });

      return {
        ...current,
        markets: updatedMarkets,
      };
    });

    setIsOpen(false);
    setSelectedToAdd(null);
  };

  const handleChange = (selectedIds: string[]) => {
    const selectedOptions = allMarkets.filter((market) =>
      selectedIds.includes(market.id)
    );
    setSelectedToAdd(selectedOptions);
  };
  // const handleChange = (
  //   value: string | number | (string | number)[]
  // ) => {
  //   setSelectedToAdd(value ? [String(value)] : null)
  // };
  return (
    <Modal
      title="Add New Market"
      centered
      open={isOpen}
      onCancel={() => {
        setIsOpen(false);
        setSelectedToAdd(null);
      }}
      style={{
        width: "28vw",
        height: "32vh",
      }}
      bodyStyle={{
        height: "calc(32vh - 108px)",
        // overflowY: "hi",
      }}
      footer={
        <div className="inline-flex justify-end gap-x-2 w-full md:w-auto">
          <NavigationButton
            onClick={() => {
              setIsOpen(false);
              setSelectedToAdd(null);
            }}
            label="Cancel"
            type="text"
          />
          <NavigationButton onClick={handleSave} label="Save" type="primary" />
        </div>
      }
    >
      <div className="py-8">
        <label className="common-label pb-[6px]">Market Name</label>
        <Select
          mode="multiple"
          className="w-full rounded-md border-gray-300  focus:border-blue-500 focus:ring focus:ring-blue-200 min-h-[40px]"
          options={allMarkets
            .filter(
              (market) => !selectedMarkets.some((m) => m.name === market.name)
            )
            .map((market) => ({
              label: market.name,
              value: market.id,
            }))}
          value={selectedToAdd?.map((item) => item.id)}
          onChange={handleChange}
          placeholder="Select a market"
          optionFilterProp="label"
        />
      </div>
    </Modal>
  );
};

export default AddMarketModal;
